import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';
import { ROUTES } from '../../constants/routes';

export const PublicFooter: React.FC = () => {
    return (
        <footer className="bg-background-dark border-t border-white/5 py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
                    <div className="col-span-1 md:col-span-1">
                        <div className="flex items-center gap-2 mb-4">
                            <div className="size-6 text-brand">
                                <ShieldCheckIcon className="w-full h-full" />
                            </div>
                            <span className="text-lg font-bold font-display text-white">FortifyTech</span>
                        </div>
                        <p className="text-gray-500 text-sm">
                            Fortaleciendo tu futuro digital con soluciones tecnológicas avanzadas.
                        </p>
                    </div>
                    <div>
                        <h4 className="text-white font-bold mb-4">Servicios</h4>
                        <ul className="space-y-2 text-sm text-gray-500">
                            <li><Link to={ROUTES.SECURITY} className="hover:text-brand transition-colors">Seguridad</Link></li>
                            <li><Link to={ROUTES.IT_SOLUTIONS} className="hover:text-brand transition-colors">Soluciones TI</Link></li>
                            <li><Link to={ROUTES.SOFTWARE_DEVELOPMENT} className="hover:text-brand transition-colors">Desarrollo de Software</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-white font-bold mb-4">Empresa</h4>
                        <ul className="space-y-2 text-sm text-gray-500">
                            <li><Link to={ROUTES.ABOUT} className="hover:text-brand transition-colors">Nosotros</Link></li>
                            <li><Link to={ROUTES.CAREERS} className="hover:text-brand transition-colors">Trabaja con Nosotros</Link></li>
                            <li><Link to={ROUTES.BLOG} className="hover:text-brand transition-colors">Blog</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-white font-bold mb-4">Legal</h4>
                        <ul className="space-y-2 text-sm text-gray-500">
                            <li><Link to={ROUTES.PRIVACY_POLICY} className="hover:text-brand transition-colors">Política de Privacidad</Link></li>
                            <li><Link to={ROUTES.TERMS_OF_SERVICE} className="hover:text-brand transition-colors">Términos de Servicio</Link></li>
                            <li><Link to={ROUTES.COMPLIANCE} className="hover:text-brand transition-colors">Cumplimiento</Link></li>
                            <li><Link to={ROUTES.SECURITY} className="hover:text-brand transition-colors">Seguridad</Link></li>
                            <li><Link to={ROUTES.DELETE_DATA} className="hover:text-brand transition-colors">Eliminación de Datos</Link></li>
                            <li><Link to={ROUTES.CONTACT_SUPPORT} className="hover:text-brand transition-colors">Soporte</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="mt-12 pt-8 border-t border-white/5 text-center text-gray-600 text-sm">
                    &copy; 2024 FortifyTech. Todos los derechos reservados.
                </div>
            </div>
        </footer>
    );
};
